import React, { useState, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import { Button, Input, Spin, Typography, message } from "antd";
import AdminHeaderTab from "../../../Components/headerTab/AdminHeaderTab";
import { RankingAlgorithmSettingsAPI } from "../../../API/admin/RankingAlgorithmSettinsAPI";
import { SimulateRankingModel } from "./SimulateRankingModel";
import { FlightModalAPI } from "../../../API/FlightModalAPI";
import { useFlightModel } from "../../../contexts/FlightModelContext";

const { Text } = Typography;

function RankingAlgorithmSettins() {
  const [messageApi, contextHolder] = message.useMessage();
  const [spinning, setSpinning] = useState(false);
  const [parameterConfig, setParameterConfig] = useState([]);
  const [simulateRankingModalOpen, setSimulateRankingModalOpen] = useState(false);
  // const [selectedFlight, setSelectedFlight] = useState(null);
  const { selectedFlightModel, refreshFlightModels } = useFlightModel();
  console.log("selectedFlightModel",selectedFlightModel);
  

  const messageToast = useCallback(
    (type, content) => {
      messageApi.open({ type, content, duration: 6 });
    },
    [messageApi]
  );

  // const getRankingWeights = useCallback(async () => {
  //   setSpinning(true);
  //    await FlightModalAPI.getFlightModals()
  //             .then(res => {
  //                 if (res?.data?.status === true) {
  //                     const arr = [{ value: null, label: '--select--' }]
  //                     res.data?.flight_models.forEach(ele => { arr.push({ value: ele, label: ele }) })
  //                     setSelectedFlight(res?.data?.selected_flight_model)
  //                     localStorage.setItem("flight_model", res?.data?.selected_flight_model)
  //                 } else {
  //                     messageToast("error", res.data?.message)
  //                 }
  //             })
  //             .catch(() => messageToast("error", "Internal Server Error"))

  //   const queryParams = {
  //     params: {
  //       flight_model: res?.data?.selected_flight_model,
  //     },
  //   };

  //   await RankingAlgorithmSettingsAPI.getRankingWeights(queryParams)
  //     .then((res) => {
  //       if (res.data) {
  //         const config = res.data.map((item) => ({
  //           key: item.name,
  //           label: item.description,
  //           valueFrom: "", // editable field
  //           valueTo: item.value, // disabled field from API
  //         }));

  //         setParameterConfig(config);
  //       } else {
  //         messageToast("error", res.data?.message);
  //       }
  //     })
  //     .catch(() => {
  //       messageToast("error", "Internal Server Error");
  //     })
  //     .finally(() => {
  //       setSpinning(false);
  //     });
  // }, [messageToast]);
  // const getRankingWeights = useCallback(async () => {
  //   try {
  //     setSpinning(true);
  //     const flightRes = await FlightModalAPI.getFlightModals();

  //     if (flightRes?.data?.status !== true) {
  //       messageToast("error", flightRes?.data?.message);
  //       setSpinning(false);
  //       return;
  //     }

  //     const selectedFlightModel = flightRes?.data?.selected_flight_model;

  //     const arr = [{ value: null, label: "--select--" }];
  //     flightRes?.data?.flight_models?.forEach((ele) => {
  //       arr.push({ value: ele, label: ele });
  //     });

  //     setSelectedFlight(selectedFlightModel);
  //     localStorage.setItem("flight_model", selectedFlightModel);

      
  //     const queryParams = {
  //       params: {
  //         flight_model: selectedFlightModel,
  //       },
  //     };

  //     const rankingRes = await RankingAlgorithmSettingsAPI.getRankingWeights(queryParams);

  //     if (rankingRes?.data) {
  //       const config = rankingRes.data.map((item) => ({
  //         key: item.name,
  //         label: item.description,
  //         valueFrom: "", 
  //         valueTo: item.value,
  //       }));

  //       setParameterConfig(config);
  //     } else {
  //       messageToast("error", rankingRes?.data?.message);
  //     }
  //   } catch (error) {
  //     messageToast("error", "Internal Server Error");
  //   } finally {
  //     setSpinning(false);
  //   }
  // }, [messageToast]);

  const getRankingWeights = useCallback(async () => {
    try {
      setSpinning(true);
      let flightModelToUse = selectedFlightModel;
      if (!flightModelToUse) {
        const refreshed = await refreshFlightModels();
        flightModelToUse = refreshed?.selectedFlightModel || null;
      }

      if (!flightModelToUse) {
        messageToast("error", "No flight model selected.");setSpinning(false);
        return;
      }

      
      const queryParams = {
        params: {
          flight_model: flightModelToUse,
        },
      };

      const rankingRes = await RankingAlgorithmSettingsAPI.getRankingWeights(queryParams);

      if (rankingRes?.data) {
        const config = rankingRes.data.map((item) => ({
          key: item.name,
          label: item.description,
          valueFrom: "", 
          valueTo: item.value,
        }));

        setParameterConfig(config);
      } else {
        messageToast("error", rankingRes?.data?.message);
      }
    } catch (error) {
      messageToast("error", "Internal Server Error");
    } finally {
      setSpinning(false);
    }
  }, [messageToast, refreshFlightModels, selectedFlightModel]);



  useEffect(() => {
    getRankingWeights();
  }, [getRankingWeights]);

 

  async function saveConfiguration() {
    setSpinning(true);

    const bodyData = {
      weights: parameterConfig.reduce((acc, { key, valueFrom, valueTo }) => {
        acc[key] = valueFrom !== "" ? valueFrom : valueTo;
        return acc;
      }, {}),
    };

    await RankingAlgorithmSettingsAPI.saveRankingWeights(selectedFlightModel, bodyData)
      .then((res) => {
        if (res.data.status === true) {
          messageToast("success", "Weights updated and normalised.");

          setParameterConfig((prev) =>
            prev.map((param) => ({
              ...param,
              valueFrom: "",
            }))
          );
          getRankingWeights();
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch(() => {
        messageToast("error", "Failed to save configuration.");
      })
      .finally(() => {
        setSpinning(false);
      });
  }

  async function resetToDefault() {
    setSpinning(true);

    await RankingAlgorithmSettingsAPI.restoreDefaultWeights(selectedFlightModel)
      .then((res) => {
        if (res.data.status === true) {
          setParameterConfig((prev) =>
            prev.map((param) => ({
              ...param,
              valueFrom: "",
              valueTo: res.data.restored_weights[param.key],
            }))
          );

          messageToast("success", "Configuration reset to default successfully.");
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch(() => {
        messageToast("error", "Failed to reset configuration to default.");
      })
      .finally(() => {
        setSpinning(false);
      });
  }

  function handleInputChange(key, value) {
    const regex = /^[0-9]*\.?[0-9]{0,16}$/;

    if (regex.test(value) || value === "") {
      if (value === "") {
        setParameterConfig((prev) =>
          prev.map((param) =>
            param.key === key ? { ...param, valueFrom: "" } : param
          )
        );
      } else {
        let decimalValue = value;

        if (decimalValue.includes(".")) {
          const parts = decimalValue.split(".");
          parts[1] = parts[1].slice(0, 16);
          decimalValue = parts.join(".");
        }

        if (parseFloat(decimalValue) > 10) decimalValue = "10";
        if (parseFloat(decimalValue) < 0) decimalValue = "0";

        setParameterConfig((prev) =>
          prev.map((param) =>
            param.key === key ? { ...param, valueFrom: decimalValue } : param
          )
        );
      }
    }
  }

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimzer | Ranking Algorithm Settings</title>
      </Helmet>

      <AdminHeaderTab currrentTab="Ranking Algorithm Settings" />

      <Spin spinning={spinning}>
        <div className="admin_tab_content_wraper">
          <div className="table_head_wraper">
            <Text className="table_head">Ranking Algorithm Settings</Text>
          </div>

          <div
            style={{
              padding: "20px",
              backgroundColor: "#fff",
              borderRadius: "8px",
              marginTop: "20px",
            }}
          >
            {parameterConfig.map((param) => (
              <div key={param.key} style={{ marginBottom: "25px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                  <label
                    style={{
                      color: "#666666",
                      fontSize: "14px",
                      fontWeight: 500,
                      minWidth: "280px",
                    }}
                  >
                    {param.label}
                  </label>
                  <Input
                    type="text"
                    value={param.valueFrom}

                    onChange={(e) =>
                      handleInputChange(param.key, e.target.value)
                    }
                    style={{
                      width: "200px",
                      textAlign: "right",
                      backgroundColor: "#fff",
                    }}
                  />

                  {/* Disabled API Field */}
                  <Input
                    type="text"
                    value={param.valueTo}
                    disabled
                    style={{
                      width: "200px",
                      textAlign: "right",
                      backgroundColor: "#f5f5f5",
                    }}
                  />
                </div>
              </div>
            ))}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
                gap: "1rem",
              }}
            >
              <Button
                onClick={resetToDefault}
                disabled={parameterConfig.length === 0}
                style={{
                  backgroundColor: "#fff",
                  color: "#595959",
                  borderColor: "#d9d9d9",
                }}
              >
                Reset to Default
              </Button>

              <Button
                type="primary"
                onClick={saveConfiguration}
                disabled={parameterConfig.length === 0}
                style={{ backgroundColor: "#1890FF" }}
              >
                Save Configuration
              </Button>

              <Button
                type="primary"
                onClick={() => setSimulateRankingModalOpen(true)}
                disabled={parameterConfig.length === 0}
                style={{ backgroundColor: "#328DF8" }}
              >
                Simulate Ranking
              </Button>
            </div>
          </div>
        </div>
      </Spin>

      <SimulateRankingModel
        open={simulateRankingModalOpen}
        setOpen={setSimulateRankingModalOpen}
        messageToast={messageToast}
      />

      {contextHolder}
    </div>
  );
}

export default RankingAlgorithmSettins;